import {useSettingsQuery} from '../../../common/providers/ApiInterface'

export const useDepartmentTypesForArea = (areaTypeId?: string) => {
  return useSettingsQuery('upmDepartmentTypes', [], {
    gcTime: 0,
    retry: false,
    staleTime: 0,
    enabled: !!areaTypeId,
    select: (data) => {
      if (areaTypeId) {
        return data.filter((dept) => dept.areaTypeId === areaTypeId)
      }
      return data
    }
  })
}

export const QueryKey = 'upmDepartmentTypes'
